// src/components/TemplateWorkspace/workspaceUploads/VideoPreview.jsx

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { auth, db } from '../../../../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import ProcessingBar from '../../../../components/appComponents/ProcessingBar';
import useProcessingProgress from '../../../../components/appComponents/useProcessingProgress';
import previewThumbnail from '../../../../assets/images/thumbnail/preview-thumbnail.png';
import './linkWorkspace.css';

const VideoPreview = ({
  details,
  content_id,
  isProcessing,
  errorMessage,
  isTranscriptError,
  done
}) => {
  const [job, setJob] = useState(null); // the workspace doc while it processes
  const user = auth.currentUser;
  const docKey = `workspace-${content_id}`;
  const percent = useProcessingProgress({ active: isProcessing, source: 'youtube', id: content_id, job });

  // While processing, follow the workspace doc (start time, duration, chunks) for the progress bar
  useEffect(() => {
    if (!user || !isProcessing || !content_id) return undefined;
    const wsRef = doc(db, 'users', user.uid, 'workspaceContent', docKey);
    return onSnapshot(wsRef, snap => setJob(snap.exists() ? snap.data() : null));
  }, [user, content_id, isProcessing, docKey]);

  return (
    <section className="worklink-workspace-video-details">
      <div className="worklink-video-card">
        <div className="worklink-video-overlay" />

        <div
          className="worklink-video-thumbnail-container"
          style={{ position: 'relative' }}
        >
          {done && details.videoId ? (
            <a
              href={`https://youtu.be/${details.videoId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={details.thumbnailUrl || previewThumbnail}
                alt="Video Thumbnail"
                className="worklink-video-thumbnail"
              />
            </a>
          ) : (
            <img
              src={details.thumbnailUrl || previewThumbnail}
              alt="Video Thumbnail"
              className="worklink-video-thumbnail"
            />
          )}

          {/* Error overlay */}
          {isTranscriptError && (
            <div className="worklink-error-video-thumbnail-overlay">
              <div className="worklink-error-message-box">
                <div className="worklink-error-message">
                  <FontAwesomeIcon
                    icon={faCircleExclamation}
                    className="worklink-error-icon"
                  />
                  Try Again
                </div>
                <Link to="/workspace" className="worklink-reupload-button">
                  New workspace
                </Link>
              </div>
            </div>
          )}

          {/* legacy errorMessage */}
          {!isTranscriptError && errorMessage && !done && (
            <div className="worklink-error-video-thumbnail-overlay">
              <div className="worklink-error-message-box">
                <div className="worklink-error-message">{errorMessage}</div>
                <div className="worklink-retry-message">
                  Learn more{' '}
                  <a
                    href="/help/articles/9126173-why-won-t-my-videos-process"
                  >
                    here
                  </a>.
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Title always shown when available */}
        {details.title && (
          <div className="worklink-video-title-DONE">
            <b>
              {details.title.length > 72
                ? `${details.title.slice(0, 72)}…`
                : details.title}
            </b>
          </div>
        )}

        {/* Progress bar below title area, outside thumbnail overflow:hidden */}
        {!isTranscriptError && isProcessing && (
          <div className="links-progress-wrapper">
            <ProcessingBar percent={percent} />
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoPreview;
